import { TabList } from '@mui/lab';
import { Box, styled, Tab } from '@mui/material';

export const StyledTabList = styled(TabList)(({ theme }) => ({
  // position: 'absolute',
  // top: 0,
  // marginLeft: '-40px',
  // paddingRight: '-60px',
  background: '#F5F5F4',
  borderWidth: '0 0 1px 0',
  borderStyle: 'solid',
  borderColor: '#D0D5DD',
  overflowX: 'auto',
  overflowY: 'hidden',
  flex: 1,
  minWidth: 0,

  '& .MuiTabs-flexContainer': {
    gap: 1,
  },

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.secondary.main,
  },

  '& .MuiTabs-scroller': {},
}));

export const StyledTab = styled(Tab)(() => ({
  background: '#F5F5F4',

  minWidth: 0,
  width: 210,

  '&.Mui-selected': {
    backgroundColor: '#FFFFFF',
    color: '#1A1A1A',
  },
}));

export const TabLabel = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '16px 20px',
  flex: '1 0 0',

  '& > div': {
    minWidth: 0,
    flex: 1,
    marginLeft: '20px',
    // display: 'flex',
    // flexDirection: 'column',
    // alignItems: 'flex-end',
  },

  '.title': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '140%',
    fontStyle: 'normal',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    color: '#475467',
    width: '144px',
    textAlign: 'start',
  },

  '.subtitle': {
    textAlign: 'start',
    width: '144px',
    fontSize: '14px',
    color: '#1A1A1A',
    fontWeight: 500,
    lineHeight: 'normal',
    textTransform: 'none',
  },
}));

export const ButtonBox = styled(Box)(() => ({
  background: '#F5F5F4',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  borderWidth: '0 1px 1px 0',
  borderStyle: 'solid',
  borderColor: '#D0D5DD',
}));
